import { vuexfireMutations, firestoreAction } from "vuexfire"

const getDefaultState = () => {
	return {
		index: [],
		current: {},
		allSubclasses: {},
	}
}

export const state = () => ({
	index: [],
	current: {},
	allSubclasses: {}, // New: stores subclasses by class ID
})

export const mutations = {
	...vuexfireMutations,
	SET_INDEX(state, docs) {
		state.index = docs
	},
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	SET_ALL_SUBCLASSES(state, subclassesByClass) {
		state.allSubclasses = subclassesByClass
	},
}

export const actions = {
	bind: firestoreAction(async function ({ bindFirestoreRef }, payload) {
		const ref = this.$fire.firestore.collection(`classes/${payload.class_id}/subclasses`).doc(payload.subclass_id)
		await bindFirestoreRef("current", ref, { wait: true })
	}),
	unbind: firestoreAction(function ({ unbindFirestoreRef }) {
		unbindFirestoreRef("current", () => {
			return []
		})
	}),
	async bindIndex({ commit }, id) {
		const ref = this.$fire.firestore.collection(`classes/${id}/subclasses`).orderBy("title", "asc")
		ref.onSnapshot((snapshot) => {
			const docs = snapshot.docs.map((doc) => ({
				id: doc.id,
				title: doc.data().title,
			}))
			commit("SET_INDEX", docs) // Always use commit to change state
		})
	},
	reset({ commit, dispatch }) {
		dispatch("unbind")
		commit("RESET_STATE")
	},
	async loadAllSubclasses({ commit }, classIds) {
		const allSubclasses = {}
		for (const classId of classIds) {
			try {
				const ref = this.$fire.firestore.collection(`classes/${classId}/subclasses`).orderBy("title", "asc")
				const snapshot = await ref.get()
				allSubclasses[classId] = snapshot.docs.map((doc) => ({
					id: doc.id,
					title: doc.data().title,
					class_id: classId,
				}))
			} catch (error) {
				console.warn(`Failed to load subclasses for class ${classId}:`, error)
				allSubclasses[classId] = []
			}
		}
		commit("SET_ALL_SUBCLASSES", allSubclasses)
	},
}

export const getters = {
	getIndex(state) {
		return state.index
	},
	getCurrent(state) {
		return state.current
	},
	getLabelledIndex(state) {
		const transformed = state.index.map(({ title, id }) => ({
			label: title,
			value: id,
		}))
		return transformed
	},
	getFilterOptions(state) {
		return state.index.map(({ title, id }) => ({
			label: title,
			value: title,
		}))
	},
}
